import { createSlice, isAction } from "@reduxjs/toolkit";
import {
  addcompletedTask,
  fetchcompletedTaskById,
  fetchcompletedTasks,
  updatecompletedTask,
} from "./thunk";

interface completedTaskState {
  completedTaskList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedcompletedTask: any;
}

const initialState: completedTaskState = {
  completedTaskList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedcompletedTask: null,
};

const completedTaskSlice = createSlice({
  name: "completedTask",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchcompletedTasks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchcompletedTasks.fulfilled, (state, action) => {
        state.loading = false;
        state.completedTaskList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchcompletedTasks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch completedTasks";
      })
      .addCase(fetchcompletedTaskById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchcompletedTaskById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedcompletedTask = action.payload;
      })
      .addCase(fetchcompletedTaskById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addcompletedTask.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.completedTaskList = state.completedTaskList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(addcompletedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to add completedTasks";
      })
      .addCase(updatecompletedTask.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.completedTaskList = state.completedTaskList.map((pkg) =>
          pkg.id === action.payload.id ? action.payload : pkg
        );
      })
      .addCase(updatecompletedTask.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update completedTasks";
      });
    // .addCase(updateStatusInPkg.fulfilled, (state, action) => {
    //   if (!action.payload?.data.id) return;
    //   state.completedTaskList = state.completedTaskList.map((pkg) =>
    //     pkg.id === action.payload.data.id ? action.payload.data : pkg
    //   );
    // })

    // .addCase(updateStatusInPkg.rejected, (state, action) => {
    //   state.loading = false;
    //   state.error = action.error.message || "Failed to fetch completedTasks";
    // });
  },
});

export default completedTaskSlice.reducer;
